<template>
    <div class="container-fluid">
      <section class="profile-shell">
        <div class="profile-hero">
          <div class="profile-hero-copy">
            <p class="hero-eyebrow">My Profile</p>
            <h1>Manage your personal account details</h1>
            <p class="hero-text">Review your account information, contact details and sign-in credentials in one secure profile space.</p>
          </div>
          <div class="profile-summary-card">
            <div class="profile-summary-top">
              <img src="../assets/profile_img.png" alt="" class="p-img">
              <div class="profile-summary-copy">
                <strong>{{ vfirstname }} {{ vlastname }}</strong>
                <span>{{ vemail }}</span>
              </div>
            </div>
            <div class="profile-summary-meta">
              <div class="summary-meta-item">
                <span class="summary-label">Username</span>
                <strong>{{ vusername }}</strong>
              </div>
              <div class="summary-meta-item">
                <span class="summary-label">Date Joined</span>
                <strong>{{ date_joined ? new Date(date_joined).toDateString() : 'Not available' }}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="package-container">
            <div class="product">
                <div class="product-0">
                    <div class="profile-section-header">
                      <div>
                        <p class="section-eyebrow">Account Information</p>
                        <h3>Personal details</h3>
                      </div>
                    </div>
                    <div class="product-1">
                      <div class="product-1-info">
                        <span>First name</span>
                        <span class="info-value">{{vfirstname}}</span>
                      </div>
                      <div class="product-1-info">
                        <span>Last name</span>
                        <span class="info-value">{{vlastname}}</span>
                      </div>
                      <div class="product-1-info">
                        <span>Email</span>
                        <span class="info-value">{{vemail}}</span>
                      </div>
                      <div class="product-1-info">
                        <span>Phone</span>
                        <span class="info-value">{{vphone}}</span>
                      </div>
                      <div class="product-1-info">
                        <span>Date joined</span>
                        <span class="info-value">{{ date_joined ? new Date(date_joined).toDateString() : 'Not available' }}</span>
                      </div>
                    </div>                   
                </div>
                <div class="product-2">
                  <div class="profile-section-header compact">
                    <div>
                      <p class="section-eyebrow">Security</p>
                      <h3>Update Pin</h3>
                    </div>
                  </div>
                  <div class="product-2-info">
                    <span>Username</span>
                    <span class="info-value">{{vusername}}</span>
                  </div>
                  <div class="product-2-info">
                    <span>Pin</span>
                    <button class="edit-password-btn" @click="editPassword()"><i class="fa fa-edit"></i> Change Pin</button>
                  </div>
                </div>
            </div>   
        </div>
      </section>
        <div v-if="isEditPassword">
          <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper col-md-4 profile-modal" style="margin:auto">
                    <div class="row">
                        <div class="col-md-0">
                        </div>
                        <div class="col-md-12">
                            <div class="account-content">
                                <div class="account-content-h">
                                   Change Pin
                                </div>
                                <div class="account-content-d">
                                  <span>New pin</span><br>
                                  <input type="password" class="form-control" placeholder="Pin" v-model="password">
                                  <span>Confirm pin</span><br>
                                  <input type="password" class="form-control" placeholder="Confirm Pin" v-model="confirm_password">
                                </div>
                                <button class="btn btn-success profile-submit-btn" :disabled="isSubmitButtonDisabled" @click="submit()" v-if="!loading">Save Password</button>
                                <button class="btn btn-success btn-block" type="button" disabled v-if="loading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </button>
                                <button class="btn btn-default profile-close-btn" @click="isEditPassword = false">Close</button>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="col-md-0">                         
                        </div>
                    </div>
                </div>
            </div>
          </transition>
        </div>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    <script>
    import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    export default {
        name: "ProfilePage",
        components: {
            PageLoader
        },
      
        data(){
          return {
    
              isLoading: false,
              isEditPassword: false,
              user_id: '',
              firstname: '',
              lastname: '',
              bank_name:'',
              account_name:'',
              account_number: '',
              ussd: '',
              exp_time: '',
              referral_code: '',
              loading: false,
              plans: [],      
              transfer_data: [], 
              current_plan: '',   
              profile: '',

              vfirstname: '',
              vlastname: '',
              vemail: '',
              vphone: '',
              vusername: '',
              vplan:'',
              vamount: '0.00',
              vaccount_name: '',
              vbank: '',
              vaccount: '',
              date_joined: '',
              plan_active_status: '',

              password: '',
              confirm_password: '',
          };
        },
      
        beforeMount(){
         
        },
      
        mounted(){
    
            this.firstname = localStorage.getItem("firstname");
            this.lastname = localStorage.getItem("lastname");
            this.phone_number = localStorage.getItem("phone");
            this.email_address = localStorage.getItem("email");
            this.user_id = localStorage.getItem("userid");
            this.referral_code = localStorage.getItem("referral_code");
            this.fetchProfile()
        },
      
        created(){
              
        },
      
        computed: {
          isSubmitButtonDisabled() {
            return (
              this.password === '' ||
              this.confirm_password === ''
            );
          }
        },
      
        methods: {
        
           generateRandomId() {
              return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
           },
    
            setShowBtn(index, value) {
              this.$set(this.showBtn, index, value);
            },
    
            async fetchProfile() {
                try {
    
                   this.isLoading = true
                   const response =  await this.$http.post('/fetch-current-plan', {
                        userid: this.user_id
                    })
                    this.isLoading = false
                    this.profile = response.data.users
                    this.vfirstname = this.profile[0].firstname
                    this.vlastname = this.profile[0].lastname
                    this.vusername = this.profile[0].username
                    this.vemail = this.profile[0].email_address
                    this.vphone = this.profile[0].phone_number

                    this.vplan = this.profile[0].plan_name
                    this.vamount = this.profile[0].amount 
                    this.vaccount_name= this.profile[0].account_name
                    this.vbank = this.profile[0].bank_name
                    this.vaccount = this.profile[0].account_number
                    this.date_joined = this.profile[0].created_at
                    this.plan_active_status = this.profile[0].plan_active_status
                        
                } catch (err) {
                  console.log(err);
              }
            },

            editPassword(){
              this.isEditPassword = true
            },

            async submit(){
              try {
  
                    this.loading = true
                    const response =  await this.$http.post('/update-password', {
                        userid: this.user_id,
                        password: this.password,
                        confirm_password: this.confirm_password
                    })
                    this.loading = false
                    if(response.data.success){
                        swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                      })
                      this.isEditPassword = false
                      return;
                    }
                        
                } catch (err) {
                  console.log(err);
                }
            }
        }
    }
    </script>
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;500;700&display=swap');
    .container-fluid{
    background:
    radial-gradient(circle at top left, rgba(36, 86, 43, 0.12), transparent 24%),
    linear-gradient(180deg, #f4f8f5 0%, #edf3ee 100%);
    border-radius: 10px;
    padding: 1.25rem 1rem 2rem;
    min-height: 100vh;
    }
    .profile-shell{
      max-width: 1100px;
      margin: 0 auto;
      font-family: Mulish;
    }
    .profile-hero{
      display: grid;
      grid-template-columns: 1.35fr 1fr;
      gap: 1.2rem;
      margin-bottom: 1.25rem;
      align-items: stretch;
    }
    .profile-hero-copy{
      padding: 2rem;
      border-radius: 28px;
      background: linear-gradient(135deg, #16372d 0%, #24562B 58%, #3d7c50 100%);
      box-shadow: 0 20px 45px rgba(11, 39, 24, 0.1);
      color: #fff;
    }
    .hero-eyebrow{
      margin: 0 0 0.65rem;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      color: rgba(255,255,255,0.72);
    }
    .profile-hero-copy h1{
      margin: 0;
      font-size: 32px;
      line-height: 1.15;
      font-weight: 700;
    }
    .hero-text{
      margin: 0.9rem 0 0;
      max-width: 520px;
      font-size: 14px;
      line-height: 1.75;
      color: rgba(255,255,255,0.84);
    }
    .profile-summary-card{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 1.3rem;
      border-radius: 28px;
      background: rgba(255,255,255,0.8);
      box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07);
      backdrop-filter: blur(10px);
    }
    .profile-summary-top{
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    .profile-summary-copy{
      display: flex;
      flex-direction: column;
      gap: 0.35rem;

      strong{
        font-size: 24px;
        line-height: 1.2;
        color: #16372d;
      }

      span{
        font-size: 13px;
        color: #64756d;
        word-break: break-word;
      }
    }
    .profile-summary-meta{
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.85rem;
      margin-top: 1rem;
    }
    .summary-meta-item{
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      padding: 0.9rem 1rem;
      border-radius: 18px;
      background: linear-gradient(180deg, #ffffff 0%, #f4f8f5 100%);
      border: 1px solid rgba(22, 55, 45, 0.08);

      strong{
        font-size: 14px;
        color: #16372d;
        word-break: break-word;
      }
    }
    .summary-label{
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #71857a;
    }
    .modal-mask {
      position: fixed;
      z-index: 1050;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .55);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity .4s ease;
    
      &>div {
          width: min(430px, calc(100vw - 24px));
          height: auto;
          background: #fff;;
          backdrop-filter: blur(13px);
          border-radius: 24px;
          box-sizing: border-box;
          font-family: Mulish;
          box-shadow: 0 20px 45px rgba(0, 0, 0, 0.18);
      }
    
      h3 {
          margin-top: 10px;
          font-size: 18px;
          color: #000;
          font-weight: bold;
          font-family: Mulish;
      }
    }
    .account-content{
      display: flex;
      flex-direction: column;
      justify-content: center;  
      //margin-right: 8px;
    }
    .account-content-h{
      display: flex;
      flex-direction: column;
      justify-content: center;  
      align-items: center;
      width: 100%;
      height: 50px;   
      //margin: 4px;
      padding-top: 1.3rem;
      text-transform: uppercase;
      text-align: center;
      font-weight: bold;
    }
    .account-content-d{
      padding-top: 1.3rem;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .btn-success{
      background: #24562B;   
      border: solid 0px;
      margin-bottom: 10px;
    }
    .p-img{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0px;
      width: 84px;
      height: 84px;
      background: linear-gradient(135deg, #16372d 0%, #24562B 100%);
      border-radius: 47px;
      margin: 0;
      object-fit: cover;
    }
    .active-status{
      background: #312f334b;
      border-radius: 4px;
      margin: 10px;
      width: 80px;
      height: 40px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .package-container{
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 0;
        background: transparent;
        width: 100%;
      }
      .product{
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-family: Mulish;
        font-size: 12px;
        border: 1px solid rgba(22, 55, 45, 0.07);
        margin-bottom: 40px;
        border-radius: 24px;
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07); 
        padding: 1.2rem;
        width: 100%;
        background: #fff;
      }
      .product-0{
        width: 100%;
      }
      .profile-section-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.9rem;

        h3{
          margin: 0.2rem 0 0;
          font-size: 20px;
          font-weight: 700;
          color: #16372d;
        }
      }
      .profile-section-header.compact{
        margin-bottom: 0.75rem;
      }
      .section-eyebrow{
        margin: 0;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #6d8377;
      }
      .product-1{
        display: flex;
        flex-direction: column;
        font-family: Mulish;
        font-size: 13px;
        border: solid 1px #e6eeea;
        margin-bottom: 10px;
        border-radius: 20px;
        box-shadow: none; 
        padding: 0.6rem;
        background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);
      }
      .product-1-info{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        margin: 0;
        padding: 0.85rem 0.6rem;
        border-bottom: solid 1px #e8efeb;
      }
      .product-1-info:last-child{
        border-bottom: 0;
      }
      .product-2{
        display: flex;
        flex-direction: column;
        font-family: Mulish;
        font-size: 13px;
        border: solid 1px #e6eeea;
        margin-bottom: 30px;
        border-radius: 20px;
        box-shadow: none; 
        padding: 0.85rem;
        width: 100%;
        background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);
      }
      .product-2-info{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        margin: 0;
        padding: 0.85rem 0.1rem;
        border-bottom: solid 1px #e8efeb;
      }
      .product-2-info:last-child{
        border-bottom: 0;
      }
      .info-value{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.4rem 0.75rem;
        border-radius: 999px;
        background: #eef5ef;
        color: #16372d;
        font-size: 12px;
        font-weight: 700;
        text-align: right;
        word-break: break-word;
      }
      .edit-password-btn{
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        border: 0;
        border-radius: 999px;
        padding: 0.6rem 0.9rem;
        background: #24562B;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        box-shadow: 0 12px 24px rgba(36, 86, 43, 0.16);
      }
      .form-control{
        height: 45px;
        margin-bottom: 8px;
        border-radius: 14px;
        border: 1px solid #dfe8e2;
      }
      .profile-modal{
        padding: 1.5rem;
      }
      .profile-submit-btn{
        border-radius: 999px;
        height: 46px;
        font-weight: 700;
      }
      .profile-close-btn{
        border-radius: 999px;
        background: #eff4f0;
        font-weight: 700;
      }
    
      .fa-user{
        font-size: 120px;
        color: #800080;
      }

      @media screen and (max-width: 991px) {
        .container-fluid{
          padding: 1rem 0.85rem 1.5rem;
        }
        .profile-hero{
          grid-template-columns: 1fr;
        }
        .profile-hero-copy{
          padding: 1.45rem;
        }
        .profile-hero-copy h1{
          font-size: 26px;
        }
        .profile-summary-meta{
          grid-template-columns: 1fr;
        }
      }
    
      @media screen and (max-width: 768px) {
        .container-fluid{
        padding: 1rem 0.75rem 1.25rem;
    }
        .modal-mask {
          position: fixed;
          //z-index: 9998;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, .5);
          display: table;
          transition: opacity .4s ease;
        
          &>div {
              width: 80%;
              height: auto;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              background: #fff;;
              backdrop-filter: blur(13px);
              border-radius: 10px;
              box-sizing: border-box;
              font-family: Mulish;
          }
        
          h3 {
              margin-top: 10px;
              font-size: 18px;
              color: #000;
              font-weight: bold;
              font-family: Mulish;
          }
        }

        .account-content{
          display: flex;
          flex-direction: column;
          justify-content: center;  
          //margin-right: 8px;
        }
        .account-content-h{
          display: flex;
          flex-direction: column;
          justify-content: center;  
          align-items: center;
          width: 100%;
          height: 50px;   
          padding-top: 1.3rem;
          text-transform: uppercase;
          text-align: center;
          font-weight: bold;
        }
        .account-content-d{
          padding-top: 1.3rem;
          font-size: 14px;
          margin-bottom: 10px;
        }
        .product-1{
          font-size: 10px;
        }
        .package-container{
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0;
          }
          .product-0{
            width: 100%;
          }
          .product{
            display: flex;
            flex-direction: column;
            padding: 1rem;
            font-family: Mulish;
            width: 100%;
    
          }
          .profile-summary-top,
          .product-1-info,
          .product-2-info{
            flex-direction: column;
            align-items: flex-start;
          }
          .info-value{
            justify-content: flex-start;
            text-align: left;
          }
          
      }
    </style>
